export default `
<svg width="64" height="78" viewBox="0 0 64 78" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <filter x="-10.7%" y="-8.6%" width="121.4%" height="117.1%" filterUnits="objectBoundingBox" id="a">
      <feOffset in="SourceAlpha" result="shadowOffsetOuter1"/>
      <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
      <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.342900815 0" in="shadowBlurOuter1"/>
    </filter>
    <path d="M28 0a28.1 28.1 0 0128 28.18c0 13.04-8.8 24.02-20.75 27.23L28 70l-7.25-14.59A28.16 28.16 0 010 28.18 28.1 28.1 0 0128 0z" id="b"/>
  </defs>
  <g fill="none" fill-rule="evenodd">
    <g transform="translate(4 4)">
      <use fill="#000" filter="url(#a)" xlink:href="#b"/>
      <use fill="#FFF" xlink:href="#b"/>
    </g>
    <path d="M19.26 25.1l11.77-6.56a2 2 0 011.94 0l11.77 6.56a.5.5 0 01.26.44v1.96a.5.5 0 01-.5.5h-25a.5.5 0 01-.5-.5v-1.96c0-.19.1-.35.26-.44zM21.5 29h21c.28 0 .5.22.5.5v15a.5.5 0 01-.5.5h-21a.5.5 0 01-.5-.5v-15c0-.28.22-.5.5-.5zm3 3h15c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-3c0-.28.22-.5.5-.5z" fill="#838383"/>
  </g>
</svg>
`;
